var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53948 12.3834L9.37823 12.6691H8.74823L8.55848 12.4171C8.54723 12.3999 7.43198 10.7334 5.99048 9.82137L5.51423 9.52137L6.11573 8.57037L6.59048 8.87037C7.62923 9.52662 8.49173 10.4851 9.00023 11.1249C9.79898 9.92112 11.6695 7.41384 14.5382 5.38059C13.198 3.68409 11.1272 2.58984 8.80298 2.58984C4.77098 2.58984 1.49048 5.87034 1.49048 9.90237C1.49048 13.9344 4.77098 17.2149 8.80298 17.2149C12.835 17.2149 16.1155 13.9344 16.1155 9.90237C16.1155 8.59962 15.769 7.37859 15.1697 6.31809C11.545 8.90262 9.56123 12.3451 9.53948 12.3834Z",
    fill: "#009163"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/Tick-Square.c93d6dc0.svg";
export { ForwardRef as ReactComponent };